import { Radio } from "lucide-react";

import { authClient } from "@/context/authClient";
import { useEditorStateStore } from "@/context/editorStateStore";
import { Button } from "@acme/ui/button";
import { Input } from "@acme/ui/input";
import { Label } from "@acme/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@acme/ui/popover";
import { useMemo, useState } from "react";
import { useLocation } from "react-router";
import { useLocalStorage } from "usehooks-ts";
import { AvatarGroup } from "./AvatarGroup";
import type { User } from "./Editor/types";
import { ShareMenu } from "./ShareMenu";
import { UserProfileDropdown } from "./UserProfile";
import { Link } from "react-router";

export const NavBar = () => {
	const { data } = authClient.useSession();
	const location = useLocation();
	const { awarenessUsers, shareCode } = useEditorStateStore();

	const [anonMeUser] = useLocalStorage<User | undefined>(
		"anonMeUser",
		undefined,
	);

	const [projectName, setProjectName] = useState<string>("Default Project");

	const displayUsers = useMemo(
		() =>
			Object.values(awarenessUsers).filter(
				(user) => user.id !== anonMeUser?.id,
			),
		[awarenessUsers, anonMeUser],
	);

	return (
		<header className="flex h-12 items-center border-b border-border bg-background px-3">
			{/* Center section */}
			<div className="absolute left-1/2 flex -translate-x-1/2 transform items-center">
				<Popover>
					<PopoverTrigger>
						<span className="font-semibold">{projectName}</span>
					</PopoverTrigger>
					<PopoverContent className="p-4">
						<Label htmlFor="maxWidth">Project Name</Label>
						<Input
							id="maxWidth"
							value={projectName}
							className="col-span-2 h-8"
							onChange={(e) => setProjectName(e.target.value)}
						/>
					</PopoverContent>
				</Popover>
			</div>
			{/* Right section */}
			<div className="ml-auto flex items-center gap-2">
				<AvatarGroup className="bg-background" users={displayUsers} />
				<Popover>
					<PopoverTrigger>
						<Button variant="ghost" size="sm" className="h-8">
							{shareCode ? (
								<>
									<Radio className="animate-pulse text-red-500" />
									Sharing
								</>
							) : (
								"Share"
							)}
						</Button>
					</PopoverTrigger>
					<PopoverContent>
						<ShareMenu />
					</PopoverContent>
				</Popover>
				{data?.session ? (
					<UserProfileDropdown />
				) : (
					<Button variant="link" asChild>
						<Link to={`/login?redirect=${encodeURIComponent(location.pathname)}`}>Sign In</Link>
					</Button>
				)}
			</div>
		</header>
	);
};
